import { Breadcrumb, HeaderToolbar } from "@xola/ui-kit";
import React from "react";
import { useHistory, useParams } from "react-router-dom";
import { Delegate, Guide } from "types";
import { NoTranslate } from "../../components/Common/NoTranslate";
import { ColumnLayout } from "../../components/Layout/ColumnLayout";
import { EditGuideForm } from "../../components/Resources/GuideManagement/EditGuide/EditGuideForm";
import { useSeller } from "../../hooks/useAccount";
import { useResource } from "../../hooks/useResource";
import { Page } from "../Page";
import { EmbeddedAppTriggerLocation } from "@/embeddedApps/EmbeddedAppTriggerLocation";

export const EditGuidePage = () => {
    const seller = useSeller();
    const { id } = useParams<{ id?: string }>();
    const history = useHistory();
    const { data: guide } = useResource<Guide>(["sellers", seller.id, "guides", id]);
    const { data: delegate } = useResource<Delegate>(["users", seller.id, "delegates", guide?.user.id]);

    const handleGuideManagementLinkClick = () => {
        history.push("/resources/guides");
    };

    return (
        <Page title="Guide Management">
            <ColumnLayout>
                <HeaderToolbar>
                    <HeaderToolbar.Breadcrumb className="truncate border-r-0">
                        <Breadcrumb.Item>Resources</Breadcrumb.Item>
                        <Breadcrumb.Item onClick={handleGuideManagementLinkClick}>Guide Management</Breadcrumb.Item>
                        <Breadcrumb.Item>{id ? <NoTranslate>{guide?.name}</NoTranslate> : "New Guide"}</Breadcrumb.Item>
                    </HeaderToolbar.Breadcrumb>
                    {id && (
                        <EmbeddedAppTriggerLocation
                            id="resources.guides.detail.headerBar"
                            context={{ guides: [{ id }] }}
                        />
                    )}
                </HeaderToolbar>

                <EditGuideForm guide={guide} delegate={delegate} />
            </ColumnLayout>
        </Page>
    );
};
